var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.clientWidth>600)?_c('remCom',{attrs:{"banner_list":_vm.banner_list}}):_c('baseCom',{attrs:{"banner_list":_vm.banner_list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }